<template>
    <el-dialog
        title="新建考核任务"
        v-model="dialogVisible"
        width="37%"
        :before-close="handleClose">
        <el-form  :label-position="labelPosition" label-width="150px" ref="form" :model="Dform" :rules="rules">
          <el-form-item  prop="name" label="任务名称">
              <el-input  v-model="Dform.name"  autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item  prop="checkUserType" label="考核对象">
            <el-select v-model="Dform.checkUserType"  placeholder="请选择">
                    <el-option v-for="item in PeopleObj" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>
        <!-- <el-form-item  prop="imei" label="考核周期">
            <el-select v-model="Tongji"  placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item> -->
        
        <el-row :gutter="20">
        <el-col :span="10">
        <el-form-item  prop="checkPeriodType" label="考核周期">
            <el-select v-model="Dform.checkPeriodType"  placeholder="请选择">
                    <el-option v-for="item in period" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="10" v-if="Dform.checkPeriodType == 'semester'">
            <el-form-item   label="" label-width="70px">
                <el-date-picker
                    v-model="timeData"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="pickerChangeFn"
                    >
               </el-date-picker>
        </el-form-item>
        </el-col>
        </el-row>

        <el-form-item  prop="approveUserType" label="考核人">
            <el-select v-model="Dform.approveUserType"  placeholder="请选择">
                    <el-option v-for="item in peopleAll" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>

        <el-row :gutter="20">
        <el-col :span="10">
            <el-form-item   label="初始分值">
              <el-input  v-model="Dform.initialSore"  autocomplete="off"></el-input>
        </el-form-item>
        
        </el-col>
        <el-col :span="10" >
            <el-form-item   label="" label-width="70px">
                <el-checkbox v-model="Dform.initialScoreRanking">初始分值加入排名</el-checkbox>
            </el-form-item>
        </el-col>
        </el-row>


        <el-row :gutter="20">
        <el-col :span="10">
         <el-form-item   label="累计得分上限">
            <el-select v-model="Dform.shangxian"  placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
            
        </el-form-item>
        </el-col>
        <el-col :span="10" >
            <el-form-item   label="" label-width="70px">
              <el-input  v-model="Dform.scoreUpLimit"  autocomplete="off" :disabled="Dform.shangxian == 2?true:false"></el-input>
        </el-form-item>
        </el-col>
        </el-row>

        <el-row :gutter="20">
        <el-col :span="10">
         <el-form-item   label="累计得分下限">
            <el-select v-model="Dform.xiaxian"  placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
         </el-form-item>
        </el-col>
        <el-col :span="10">
            <el-form-item   label="" label-width="70px">
              <el-input  v-model="Dform.scoreDownLimit"  autocomplete="off" :disabled="Dform.xiaxian == 2?true:false"></el-input>
        </el-form-item>
        </el-col>
        </el-row>

        <el-row :gutter="20">
        <el-col :span="10">
            <el-form-item   label="考试频次">
            <el-select v-model="Dform.checkFrequency"  placeholder="请选择">
                    <el-option v-for="item in pingci" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
            </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="10">
            <el-form-item  prop="iemi" label="" label-width="70px">
              <el-input  v-model="Dform.checkFrequencyCount"  autocomplete="off" placeholder="次" :disabled="Dform.checkFrequency == 'null'?true:false"></el-input>
        </el-form-item>
        </el-col>
        </el-row>
            <div class="buttom-box">
                    <el-button type="primary" @click="submitForm('form')" :loading="loading">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
import { AddTaskUpdate} from '@/assets/api/deyu.js'
import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    props: ['teacherObj'],
    data() {

        return {
            dialogVisible: true,
            labelPosition:'left',
            loading:false,
            title:'',
            Dform:{
                name:'',
                checkUserType:'',
                checkPeriodType:'',
                approveUserType:'',
                initialSore:'',
                scoreUpLimit:'',
                scoreDownLimit:'',
                checkFrequency:'',
                checkFrequencyCount:'',
                initialScoreRanking:'',
                // -----------
                xiaxian:'',
                shangxian:"",
                
            },
            timeData:[],
            checkEndTime:"",
            checkStartTime:"",


            cardid:"",
            rules: {
                name: [
                    { required: true, message: '请输入考核名称', trigger: 'change' },
                ],
                checkUserType: [
                    { required: true, message: '请选择考核对象', trigger: 'change' }
                ],
                checkPeriodType: [
                    { required: true, message: '请选择周期', trigger: 'change' }
                ],         
                approveUserType: [
                    { required: true, message: '请选择考核人', trigger: 'change' }
                ],
            },
            peopleAll: [
                {
                    value: 'all',
                    label: '全员'
                }
            ],
            options: [
                {
                    value: '1',
                    label: '自定义'
                },
                {
                    value: '2',
                    label: '不限'
                }
            ],
            period:[
                {
                    value: 'day',
                    label: '天'
                }, {
                    value: 'week',
                    label: '周'
                },
                {
                    value: 'month',
                    label: '月'
                }, {
                    value: 'semester',
                    label: '学期'
                },
            ],
            PeopleObj: [
                {
                    value: 'student',
                    label: '学生'
                }, 
                {
                    value: 'class',
                    label: '班级'
                },
                {
                    value: 'teacher',
                    label: '教师'
                },
            
            ],
            pingci: [
               {
                    value: 'day',
                    label: '天'
                }, {
                    value: 'week',
                    label: '周'
                },
                {
                    value: 'month',
                    label: '月'
                },
                {
                    value: 'null',
                    label: '不限'
                },
            
            ],
          
        }

    },
    created(){
       
    },
    mounted(){
            console.log(this.teacherObj.schoolId);
            
    },
    methods:{
        handleClose() {
            this.$emit('back')
       },
      AddClick(){
        this.deviceClick()
    },
    submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.addclick()
            } else {
                console.log(valid,'校验未通过');
                return false;
            }
            });
        },
    addclick(){
        const params = {
            name:this.Dform.name,
            checkUserType:this.Dform.checkUserType,
            checkPeriodType:this.Dform.checkPeriodType,
            approveUserType:this.Dform.approveUserType,
            initialSore:this.Dform.initialSore,
            // scoreUpLimit:this.Dform.scoreUpLimit,
            // scoreDownLimit:this.Dform.scoreDownLimit,
            scoreDownLimit:this.Dform.shangxian == '2' ? null:this.Dform.scoreDownLimit,
            scoreUpLimit:this.Dform.shangxian == '2' ? null:this.Dform.scoreUpLimit,
            checkFrequency:this.Dform.checkFrequency,
            checkFrequencyCount:this.Dform.checkFrequencyCount,
            checkStartTime:this.timeData[0],
            checkEndTime:this.timeData[1],
            initialScoreRanking:this.Dform.initialScoreRanking == true?1 :0,
            schoolId:this.teacherObj.schoolId || '',
            status:'1',

        }
        AddTaskUpdate(params).then((res) => {
            // console.log(res,'新增完成');
            ElMessage({message: '新增成功',type: 'success',})
            this.handleClose()

            
        }).catch((err) => {
            // console.log(res,'新增失败');
            this.$message({
                    type: 'error',
                    message: err.response.data.msg
             });


        })
    },

    }
    }



</script>
<style  scoped lang="scss">
    /deep/ {
        .el-input--small .el-input__wrapper{
            height: 30px;
            line-height: 35px;
            text-align: center;
            // width: 280px;
        }
        .el-input__inner{
        width: 10px !important;
        }
        .buttom-box {
            margin-top: 20px;
            text-align: center;
            margin-bottom: 10px;

    

    }
    .el-input--small{
        width: 200px;
    }
    .el-select--small .el-select__wrapper {
            width: 200px;
            height: 30px;
        }
    .el-form-item--small{
        width: 380px !important;
        // height: 20px;
    }
    }
</style>